import * as React from 'react';
import {
    Create,
    TextInput,
    required,
    SimpleForm,
    DateInput,
    SelectInput,
    minValue,
    NumberInput,
} from 'react-admin';
import { AMBITION_LMS_ID, CLASSES, COUNTRY_CODES, EXAMS, LANGUAGES, STATUSES } from '../../common/constants';
import FileUpload from '../../common/inputs/FileUpload';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import SlugInput from '../../common/inputs/SlugInput';
import { LocationsAutoComplete } from '../../common/inputs/autoCompleteInputs/LocationsAutoComplete';

const ProgramCreate = () => {
    const user = JSON.parse(localStorage.getItem('user') as string);
    const isAmbitionLms = user?.organization_id === AMBITION_LMS_ID;
    return(
    <Create redirect={'/programs'}>
        <SimpleForm>
            <FileUpload type="VIDEO_THUMBNAIL" source="image" />
            <TextInput source="name" fullWidth validate={[required()]} />
            <SlugInput source="slug" fullWidth />
            <NumberInput
                type={'number'}
                source="displayOrder"
                fullWidth
                validate={[required(), minValue(0)]}
            />
            <SelectInput
                source="status"
                label={'Status'}
                fullWidth
                validate={[required()]}
                choices={STATUSES}
            />
            <SelectInput
                source="config.class"
                label={'Class'}
                fullWidth
                validate={[required()]}
                choices={CLASSES}
            />
            <SelectInput
                source="config.language"
                label={'Language'}
                validate={[required()]}
                fullWidth
                choices={LANGUAGES}
            />
            <SelectInput
                source="config.exam"
                validate={[required()]}
                label={'Exam'}
                fullWidth
                choices={EXAMS}
            />
            {isAmbitionLms && (
                <LocationsAutoComplete
                    source="location"
                    label={"Location"}
                />
            )}
            <HTMLEditorInput source={'description'} fullWidth validate={[required(), validHtml]} />
        </SimpleForm>
    </Create>
)};

export default ProgramCreate;
